import { AdminButton } from "@/components/admin/button";
import { Card, CardHead } from "@/components/admin/card";
import { AdminIcon } from "@/components/admin/icon";
import { Tag } from "@/components/admin/tag";
import {
	useRevokeOtherSessions,
	useRevokeSession,
	useSessionsQuery,
} from "@/hooks/use-me";

export function ProfileSessionsPage() {
	const { data: sessions, isLoading } = useSessionsQuery();
	const revokeMutation = useRevokeSession();
	const revokeOthersMutation = useRevokeOtherSessions();

	return (
		<Card>
			<CardHead
				title="Sessions actives"
				sub="3 sessions simultanées max (CDC §3.1.3) · révocables individuellement"
				right={
					<AdminButton
						variant="ghost"
						size="sm"
						onClick={() => revokeOthersMutation.mutate()}
						disabled={(sessions?.filter((s) => !s.isCurrent).length ?? 0) === 0}
						data-testid="sessions-revoke-others"
					>
						<AdminIcon n="alert" s={12} />
						Déconnecter les autres
					</AdminButton>
				}
			/>
			<div className="table-wrap" style={{ margin: 0 }}>
				<table className="table">
					<thead>
						<tr>
							<th>Appareil</th>
							<th>IP</th>
							<th>Dernière activité</th>
							<th>Expiration</th>
							<th>Statut</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						{isLoading && (
							<tr>
								<td colSpan={6} className="muted center">
									Chargement…
								</td>
							</tr>
						)}
						{sessions?.map((s) => (
							<tr
								key={s.id}
								data-testid={`session-row${s.isCurrent ? "-current" : ""}`}
							>
								<td>
									<strong style={{ fontSize: 12 }}>
										{shortenUa(s.userAgent)}
									</strong>
									<div className="muted mono" style={{ fontSize: 10 }}>
										{s.id.slice(0, 8)}
									</div>
								</td>
								<td className="mono">{s.ip ?? "—"}</td>
								<td className="muted">
									{new Date(s.lastActivityAt).toLocaleString("fr-FR")}
								</td>
								<td className="muted">
									{new Date(s.expiresAt).toLocaleDateString("fr-FR")}
								</td>
								<td>
									{s.isCurrent ? (
										<Tag variant="success">Session actuelle</Tag>
									) : (
										<Tag variant="neutral">Active</Tag>
									)}
								</td>
								<td>
									{!s.isCurrent && (
										<button
											className="top-btn"
											onClick={() => revokeMutation.mutate(s.id)}
											title="Révoquer"
											data-testid={`session-revoke-${s.id}`}
										>
											<AdminIcon n="close" s={14} c="var(--a-danger)" />
										</button>
									)}
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</Card>
	);
}

function shortenUa(ua: string | null): string {
	if (!ua) return "Inconnu";
	if (ua.includes("Chrome")) return "Chrome / Chromium";
	if (ua.includes("Firefox")) return "Firefox";
	if (ua.includes("Safari")) return "Safari";
	if (ua.startsWith("curl")) return "curl";
	if (ua.startsWith("axios")) return "Axios";
	return ua.slice(0, 40);
}
